import { useEffect } from 'react';
import confetti from 'canvas-confetti';

// Milestone definitions
export const MILESTONES = [
  { amount: 50, message: "First $50 saved! 🎉", color: '#10b981' },
  { amount: 100, message: "$100 milestone! 💪", color: '#3b82f6' },
  { amount: 250, message: "Quarter way to $1K! 🌟", color: '#8b5cf6' },
  { amount: 500, message: "Half a grand! 🚀", color: '#f59e0b' },
  { amount: 1000, message: "$1,000 saved! Legend! 👑", color: '#ef4444' },
  { amount: 2500, message: "$2,500! You're unstoppable! 💎", color: '#06b6d4' },
  { amount: 5000, message: "$5K! Major achievement! 🏆", color: '#f97316' },
  { amount: 10000, message: "$10K! Financial rockstar! 🌈", color: '#ec4899' }
];

export const ACHIEVEMENT_TYPES = {
  FIRST_CONTRIBUTION: {
    message: "First contribution! 🎊",
    color: '#10b981'
  },
  FIRST_CLUB: {
    message: "Joined your first club! 🤝",
    color: '#3b82f6'
  },
  PREMIUM_MEMBER: {
    message: "Welcome to Premium! 👑",
    color: '#f59e0b'
  },
  FIRST_WITHDRAWAL: {
    message: "First withdrawal! 💰",
    color: '#8b5cf6'
  }
};

// Fire confetti with custom options
export const fireConfetti = (options = {}) => {
  const defaults = {
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: ['#4F46E5', '#F59E0B', '#10B981', '#EF4444', '#8B5CF6']
  };

  confetti({
    ...defaults,
    ...options
  });
};

// Fire multiple bursts
export const fireConfettiBurst = (count = 3, interval = 200) => {
  let fired = 0;
  const timer = setInterval(() => {
    fireConfetti({
      particleCount: 50,
      angle: 60 + (fired * 30),
      spread: 55,
      origin: { x: 0.5, y: 0.6 }
    });
    
    fired++;
    if (fired >= count) {
      clearInterval(timer);
    }
  }, interval);
};

// Celebration with random confetti from sides
export const celebrateFromSides = () => {
  const duration = 3 * 1000;
  const animationEnd = Date.now() + duration;
  
  const randomInRange = (min, max) => Math.random() * (max - min) + min;

  const interval = setInterval(() => {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      clearInterval(interval);
      return;
    }

    const particleCount = 50 * (timeLeft / duration);

    // Left side
    confetti({
      particleCount,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: ['#4F46E5', '#F59E0B', '#10B981']
    });

    // Right side
    confetti({
      particleCount,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: ['#EF4444', '#8B5CF6', '#06B6D4']
    });
  }, 250);
};

// Fireworks effect
export const fireConfettiFireworks = () => {
  const duration = 5 * 1000;
  const animationEnd = Date.now() + duration;

  const interval = setInterval(() => {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      clearInterval(interval);
      return;
    }

    confetti({
      particleCount: 100,
      startVelocity: 30,
      spread: 360,
      origin: {
        x: Math.random(),
        y: Math.random() - 0.2
      },
      colors: ['#4F46E5', '#F59E0B', '#10B981', '#EF4444', '#8B5CF6', '#EC4899']
    });
  }, 400);
};

// Realistic confetti cannon
export const fireConfettiCannon = () => {
  const count = 200;
  const defaults = {
    origin: { y: 0.7 }
  };

  function fire(particleRatio, opts) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio),
      colors: ['#4F46E5', '#F59E0B', '#10B981', '#EF4444', '#8B5CF6']
    });
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });

  fire(0.2, {
    spread: 60,
  });

  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
};

// Component that triggers confetti on mount
export default function ConfettiEffect({ type = 'burst', onComplete }) {
  useEffect(() => {
    switch (type) {
      case 'burst':
        fireConfettiBurst();
        break;
      case 'sides':
        celebrateFromSides();
        break;
      case 'fireworks':
        fireConfettiFireworks();
        break;
      case 'cannon':
        fireConfettiCannon();
        break;
      default:
        fireConfetti();
    }

    if (onComplete) {
      setTimeout(onComplete, 3000);
    }
  }, [type, onComplete]);

  return null;
}
